module.exports = __webpack_public_path__ + "img/f.913c48fe.jpg";